import { extendObservable, action } from "mobx";
import { getMatchupSlug } from "../utils/game";

class LimboStore {
  constructor(limboApi, routerStore, authStore) {
    this.limboApi = limboApi;
    this.routerStore = routerStore;
    this.authStore = authStore;

    extendObservable(this, {
      incidentsOverview: [],
      singleIncident: {},
      newIncidentMetadata: {},
      fetchIncidents: action(date => {
        this.limboApi.fetchIncidents(date).then(response => {
          this.incidentsOverview = response.data;
        });
      }),
      fetchIncident: action(incidentId => {
        return this.limboApi.fetchIncident(incidentId).then(response => {
          this.singleIncident = response.data[0];
        });
      }),
      createIncident: action(({ name, status, description, severity, eta }) => {
        const {
          gamePk,
          date: incidentDate,
          isSystemWide
        } = this.newIncidentMetadata;
        const incidentModel = {
          name,
          gamePk,
          statsapiUsername: authStore.username,
          incidentUpdates: [
            {
              status,
              description,
              severity,
              statsapiUsername: authStore.username,
              eta: eta && eta.format()
            }
          ],
          incidentDate,
          systemWide: isSystemWide
        };
        return this.limboApi.createIncident(incidentModel);
      }),
      createIncidentUpdate: action(({ status, description, severity, eta }) => {
        const incidentUpdateModel = {
          status,
          description,
          severity,
          statsapiUsername: authStore.username,
          eta: eta && eta.format()
        };

        return this.limboApi.createIncidentUpdate(
          this.singleIncident.id,
          incidentUpdateModel
        );
      }),
      updateNewIncidentMetadata: action((game, date) => {
        const { gamePk } = game;
        const gameSlug = getMatchupSlug(game);

        this.newIncidentMetadata = {
          gamePk,
          gameSlug,
          date
        };
      }),
      updateNewSystemIncidentMetadata: action(date => {
        this.newIncidentMetadata = {
          date,
          isSystemWide: true
        };
      })
    });
  }

  transitionAfterSave = () => {
    // TODO: This should probably be a function in routerStore.
    this.routerStore.history.push("/data-quality-report");
  };
}

export default LimboStore;



// WEBPACK FOOTER //
// ./src/stores/limboStore.js